<div class="raw-select container">
	@if (allowedDates === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading available dates...
		</div>
	}

	@if (allowedDates && allowedDates.length === 0) {
		<div class="loading-status">
			No raw data available for this component
		</div>
	}

	@if (allowedDates && allowedDates.length > 0) {
		<div class="row">
			<label class="col-sm-1 col-form-label">Date: </label>
			<div class="col-sm-5">
				<app-day-picker [(ngModel)]="selectedDate" (ngModelChange)="dateChange()" [allowedDates]="allowedDates"></app-day-picker>
			</div>
			@if (rawids && rawids.length > 0) {
				<label class="col-sm-2 col-form-label">Acquisition: </label>
				@if (rawids && rawids.length) {
					<div class="col-sm-4">
						<select class="form-control form-control-sm" [ngModel]="selected" (ngModelChange)="rawChange($event)">
							@for (raw of rawids; track raw) {
								<option [ngValue]="raw">{{raw.ts | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</option>
							}
						</select>
					</div>
				}
			}
			@if (rawids === undefined) {
				<div class="col-sm-6 col-form-label">
					Loading acquisitions...
				</div>
			}
			@if (rawids && rawids.length === 0) {
				<div class="col-sm-6 col-form-label">
					No acquisitions available
				</div>
			}
		</div>
	}
</div>